import { Button, Typography } from "antd";
import { useNavigate, useParams } from "react-router";
import Header from "@/components/Header/Header";

import "./index.scss";
import { useTranslation } from "react-i18next";
import { ClockCircleOutlined } from "@ant-design/icons";
import sentry4Action from "@/utils/sentry";

const WaitResult = () => {
  const { transaction_id } = useParams();

  const navigate = useNavigate();
  const { t } = useTranslation();
  const orderId = localStorage.getItem("orderId");
  const sign = localStorage.getItem("sign");
  const canResult = () => {
    sentry4Action("can order pay result", {
      order_id: orderId,
      sign: sign,
      transaction_id,
    });
    navigate({
      pathname: "/result",
      search: "?transaction_id=" + transaction_id,
    });
  };

  /**
   * 记录日志
   */
  const recordSentry = () => {
    sentry4Action("can pay result", {
      order_id: orderId,
      sign: sign,
      transaction_id,
    });
  };
  return (
    <div>
      <Header title="" />
      <div className="wait-result-box">
        <ClockCircleOutlined style={{ fontSize: "26px", color: "#8A8F96" }} />
        <div className="wait-result-title">{t("当前交易支付中，请等待")}</div>
        <Button
          type="primary"
          ghost
          size="large"
          className="can-result"
          onClick={canResult}
        >
          {t("查看支付结果")}
        </Button>
        <div className="pay-problem">
          <span>{t("支付遇到问题")}？</span>
          <Typography.Link
            href={`/pay-gateway?order-id=${orderId}&sign=${sign}`}
            onClick={recordSentry}
          >
            {t("try pay")}
          </Typography.Link>
        </div>
      </div>
    </div>
  );
};

export default WaitResult;
